import * as React from 'react';
import cn from 'classnames';
import './styles/Message.scss';
export var THEME;
(function (THEME) {
    THEME["DANGER"] = "danger";
    THEME["ATTENTION"] = "attention";
    THEME["SUCCESS"] = "success";
    THEME["INFO"] = "info";
})(THEME || (THEME = {}));
export default function Message(props) {
    var className = props.className, theme = props.theme, title = props.title, children = props.children, enlarged = props.enlarged, isSpecial = props.isSpecial;
    var contentClassNames = cn('Message', "Block_" + theme, "Block_" + theme + "_bordered", {
        Message_enlarged: enlarged,
        Message_isSpecial: isSpecial
    }, className);
    return (React.createElement("div", { className: contentClassNames },
        title && React.createElement("div", { className: "Message__title" }, title),
        React.createElement("div", null, children)));
}
Message.defaultProps = {
    className: '',
    title: '',
    enlarged: false,
    isSpecial: false
};
//# sourceMappingURL=Message.js.map